import { render, staticRenderFns } from "./FormTextConfig.vue?vue&type=template&id=1790a141&scoped=true"
import script from "./FormTextConfig.vue?vue&type=script&lang=js"
export * from "./FormTextConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1790a141",
  null
  
)

export default component.exports